module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAA2UlEQVR4AaSSsQrCMBRFW1Gcuyg46Oys/9DP6KR7v6S7fkn/QWdnHQQd7CwK8VyoQ0lJYoR7eGle3imEDIwxhTHmAbHRbDFIkqSCMRwj0WwlUYbglKbpOgbNQiYR9f94RVxcLny/8ooQ7GAPzoSIRhiG4EyIyCn4Ni2R7gMucBUcnMJE65YzNWevE0vUdk1b+0rat2mJeEs1LGAmGLrBXeuWObVmrxNL1On+8BEieuN7gTMhog2GLTjjFek+hNNC0yviTFAkaji55G0cYtAsNBKVLJ6wikSz5QcAAP//0MTwDgAAAAZJREFUAwDCdMN7Ht6hVgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add.png
// module id = QBcd
// module chunks = 167